<template>
  <GbwapsLayout title="How to Install GB WhatsApp APK on Android" :intro="pageIntro" :breadcrumb="breadcrumb">
    <div class="install-page">
      <div class="warning-box install-warning-top">
        <strong>Important:</strong>
        Back up chats before installing or updating GB WhatsApp. Use a stable Wi‑Fi connection for the APK download.
      </div>

      <section
        v-for="section in sections"
        :id="section.id"
        :key="section.id"
        class="page-section site-section">
        <h2>{{ section.h2 }}</h2>
        <ContentBlocks :blocks="section.blocks" />

        <div v-if="section.layout === 'steps'" class="install-steps-list">
          <article v-for="step in steps" :key="step.step" class="step-card">
            <div class="step-number">{{ step.step }}</div>
            <div class="step-content">
              <h3>{{ step.title }}</h3>
              <p>{{ step.text }}</p>
            </div>
          </article>
        </div>
      </section>

      <div class="warning-box">
        <strong>Disclaimer:</strong>
        GBWaps is an independent guide. Installing unofficial mods may carry ban and security risks—you decide
        whether to proceed.
      </div>

      <p class="text-center mt-24">
        <router-link to="/download/" class="btn-primary">Download GB WhatsApp APK</router-link>
      </p>
    </div>
  </GbwapsLayout>
</template>

<script>
import '@/css/gbwaps/pages.css';
import GbwapsLayout from '@/layouts/GbwapsLayout.vue';
import ContentBlocks from '@/components/gbwaps/ContentBlocks.vue';
import { INSTALL_STEPS, INSTALL_SECTIONS } from '@/data/install-content';

export default {
	name: 'InstallGbwhatsappPage',
	components: { GbwapsLayout, ContentBlocks },
	data() {
		return {
			pageIntro:
				'Install GB WhatsApp in five clear steps: allow unknown apps, download the APK, install, verify your number, and restore chats if needed.',
			breadcrumb: [{ name: 'Home', to: '/' }, { name: 'Install' }],
			steps: INSTALL_STEPS,
			sections: INSTALL_SECTIONS,
		};
	},
};
</script>
